<div class="data-export">
  <p class="data-export-text">
    {{ 'user.dataExport.before' | transloco }}<strong>{{ 'user.dataExport.bold' | transloco }}</strong>{{ 'user.dataExport.mid' | transloco }}<a (click)="goToArchives()">{{ 'user.dataExport.link' | transloco }}</a>{{ 'user.dataExport.after' | transloco }}
  </p>

  <!-- Mesmo desenho dos botões discretos do perfil (borda chanfrada + fundo de superfície). -->
  <button type="button" class="export-btn" [disabled]="buttonDisabled || exporting" (click)="exportData()">
    <span class="export-btn__inner">
      <i class="pi" [ngClass]="exporting ? 'pi-spin pi-spinner' : 'pi-download'"></i>
      {{ 'user.dataExport.button' | transloco }}
    </span>
  </button>

  <p class="data-export-status" *ngIf="statusLine as line">{{ line.key | transloco: line.params }}</p>
</div>
